import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { CustomCard } from "../../../components/Card/CustomCard";
import { ConsultCarreras} from '../../../funciones/ModalidadesFunction';
import { ConsultaSemestres} from '../../../funciones/CalifDirFunction';
import { ConsultaSecciones, EstudiantesDeudaSecc } from "../../../funciones/CobranzasFunction";
import { ConsultMetodos, ConsultCambio } from '../../../funciones/AdministracionFunction';
import { ConsultaNumCuenta } from "../../../funciones/EstCuentaFunction";

import ModalReports from '../../../components/Reportes/ModalReports';
import AlumnosMorososSecc from '../../../components/Reportes/AlumnosMorososSecc';

import EstDeudasTable from "./EstDeudasTable";

class SecDeudas extends Component {
    state = {
        valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
        carreras: [{ value: '', label: ' - Cargando Espere - ' }],
        valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
        semestres: [],
        valorSeccion: { value: '', label: '- Selecciona una Sección -', prof: '', profEmail: '' },
        secciones: [],
        preloader: <div className="text-danger">Selecciona una Carrera para comenzar</div>,
        estDeudores: [],

        metodos: [],
        cambio: "",
        cuentas: [],
        nuCuenta:"",
        openWR: false,
    }

    componentDidMount = () => {
        ConsultCarreras ((resp) => {
            this.setState({carreras: resp})
        })

        ConsultMetodos ((resp) => {
            this.setState({
                metodos: resp
            })
        })
        ConsultCambio ((resp) => {
            this.setState({
                cambio: resp
            })
        })
        ConsultaNumCuenta ((resp) => {
            this.setState({
                nuCuenta: resp[0],
                cuentas: resp[1]
            })
        })
    }

    valorSelectCarrera = (valorCarrera) => {
        this.setState({
            valorCarrera,
            valorSemestre: { value: '', label: '- Cargando Semestres -' },
            valorSeccion: { value: '', label: '- Selecciona una Sección -' },
            secciones: [],
            preloader: <div className="text-danger">Selecciona una Semestre para continuar</div>,
        }, () => {
            ConsultaSemestres(valorCarrera.value, (resp) => {
                this.setState({
                    semestres: resp[0],
                    valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
                })
            })
        });
    }

    valorSelectSemestre = (valorSemestre) => {
        this.setState({
            valorSemestre,
            valorSeccion: { value: '', label: '- Cargando Secciones -' },
            estDeudores: [],
            preloader: <div className="text-danger">Selecciona una Sección para continuar</div>,
        }, () => {
            ConsultaSecciones(valorSemestre.value, (resp) => {
                this.setState({
                    secciones: resp[0],
                    valorSeccion: { value: '', label: '- Selecciona una Sección -' },
                })
            })
        });
    }

    valorSelectSeccion = (valorSeccion) => {
        this.setState({
            valorSeccion,
            preloader: <div className="text-danger"><i className="fa fa-spinner fa-spin"></i> Cargando Estudiantes</div>,
        }, () => {
            EstudiantesDeudaSecc (valorSeccion.value, (resp) => {
                let prel = "" ;
                if (resp.length === 0) prel = "No existen coincidencias con la búsqueda seleccionada";

                this.setState({
                    estDeudores: resp,
                    preloader: prel,
                })
            })
        });
    }

    contenido = () => {
        let { valorCarrera, carreras, valorSemestre, semestres, valorSeccion, secciones, preloader, estDeudores,
            metodos, cambio, cuentas, nuCuenta } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let EstIndTable = () => {
            if (estDeudores.length === 0) return (
                <tr className="custon-back-color">
                    <td colSpan={4} style={styles}>{preloader}</td>
                </tr>
            )

            return (
                estDeudores.map (option => (
                    <EstDeudasTable key={option.id} datos={option}
                        metodos = {metodos} cambio = {cambio} cuentas = {cuentas} nuCuenta = {nuCuenta}
                        update = {() => {this.updLista()}}
                    />
                ))
            )
        }

        let contentEst = () => {
            if (estDeudores.length === 0) return (
                <div className="custom-mt-10" align="center">{preloader}</div>
            )

            return (
                <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                    <div className="table-responsive" id="lisEstDeuda" onScroll={this.update} style={{overflowY: "auto", maxHeight: "30vh"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="45%" style={styles}><strong>Estudiante</strong></td>
                                    <td width="35%" align="center" style={styles}><strong>Carrera</strong></td>
                                    <td width="20%" align="center" style={styles}><strong>Deuda</strong></td>
                                    <td width="200px" align="center" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {EstIndTable()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )
        }

        let imprimir = () => {
            switch (true) {
                case (valorCarrera.value === ""):
                    toast.error("Debes seleccionar primero una Carrera",{autoClose: 4000});
                break;
                case (valorSemestre.value === ""):
                    toast.error("Debes seleccionar un Semestre",{autoClose: 4000});
                break;
                case (valorSeccion.value === ""):
                    toast.error("Debes seleccionar una Sección",{autoClose: 4000});
                break;
                default:
                    this.setState({openWR: true})
                break;
            }
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info">
                    <Row>
                        <Col md={6}>
                            <Select
                                isSearchable ={true}
                                value={valorCarrera}
                                onChange={this.valorSelectCarrera}
                                options={carreras}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Carreras</span>
                        </Col>
                        <Col md={6}>
                            <Select
                                isSearchable ={true}
                                value={valorSemestre}
                                onChange={this.valorSelectSemestre}
                                options={semestres}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Semestres</span>
                        </Col>
                    </Row>
                </div>
                <div className="custom-alert-warning custom-mt-10">
                    <Row>
                        <Col md={9}>
                            <Select
                                isSearchable ={true}
                                value={valorSeccion}
                                onChange={this.valorSelectSeccion}
                                options={secciones}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Secciones Disponibles</span>
                        </Col>
                        <Col md={3} align="right">
                            <button onClick={imprimir} title="Imprimir el listado de los estudiantes con deudas" className="btn btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                        </Col>
                    </Row>
                </div>
                <div className="custom-mt-10">{contentEst()}</div>
            </React.Fragment>
        )
    }

    modalReporte = () => {
        let { openWR, estDeudores, valorCarrera, valorSemestre, valorSeccion } = this.state;
        if (openWR === false ) return null;

        return (
            <ModalReports
                reporte={<AlumnosMorososSecc
                            datos = {estDeudores}
                            carrera = {valorCarrera.label}
                            semestre = {valorSemestre.label}
                            seccion = {valorSeccion.label}
                        />}
                titulo={`Listado de Alumnos Morosos por Sección`}
                display= "block"
                cerrar = {() => {this.setState({openWR:false})}}
            />
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">Aqui puedes ver un listado de los estudiantes que poseen deudas agrupados por <strong className="text-danger">SECCIONES</strong> detallando los siguientes datos:</Col>

            <Col md={12} className="text-primary custom-mt-10"><strong>Estudiante</strong></Col>
            <Col md={12} align="justify">Nombre y apellido del estudiante</Col>
            
            <Col md={12} className="text-primary custom-mt-10"><strong>Carrera</strong></Col>
            <Col md={12} align="justify">Carrera actual que cursa el estudiante</Col>

            <Col md={12} className="text-primary custom-mt-10"><strong>Deuda</strong></Col>
            <Col md={12} align="justify">Es la cantidad expresada en bolívares correspondiente a la deuda actual del estudiante</Col>
        
            <Col md={12} className="text-primary custom-mt-10"><strong>Acciones</strong></Col>
            
            <Col md={12} align="justify">El botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-money"></i> Registrar Pago</button> despliega la ventana que te permite registrar el tipo de pago y la cantidad para cada estudiante</Col> 
            <Col md={12} align="justify" className="custom-mt-10">
                Para ver los estudiantes primero selecciona <strong className="text-primary">Una Carrera</strong>, luego <strong className="text-primary">Un Semestre</strong> y por último <strong className="text-primary">La Sección</strong>
            </Col>
        </Row>
    )
    
    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Deuda por Sección</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalReporte()}
            </div>
        );
    }
}
 
export default SecDeudas;


// WEBPACK FOOTER //
// ./src/views/Administracion/CobranzasContent/SecDeudas.jsx